import React, { useState, useEffect } from 'react';
import { Header } from './components/Header.tsx';
import { Hero } from './components/Hero.tsx';
import { Dashboard } from './components/Dashboard.tsx';

const App: React.FC = () => {
  const [view, setView] = useState<'landing' | 'dashboard'>('landing');
  const [theme, setTheme] = useState<'dark' | 'light'>('dark');

  // Apply theme to document
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const handleNavigate = (sectionId?: string) => {
    setView('landing');
    if (sectionId) {
        setTimeout(() => {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-background text-text selection:bg-primary/30 selection:text-white transition-colors duration-300">
      <Header onNavigate={handleNavigate} theme={theme} onToggleTheme={toggleTheme} />
      <main className="pt-16">
        {view === 'landing' ? (
          <Hero 
            onStart={() => {
                setView('dashboard');
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            onNavigate={handleNavigate}
          />
        ) : (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
             <div className="mb-8 flex items-center justify-between">
                <div>
                  <h1 className="text-2xl font-black tracking-tight text-white uppercase font-mono">
                    Forensic<span className="text-primary">_Dashboard</span>
                  </h1>
                  <p className="text-subtext text-xs font-mono uppercase tracking-widest mt-1">Status: Active Session</p>
                </div>
                <div className="flex items-center gap-4">
                  <button 
                    onClick={() => handleNavigate()}
                    className="text-[10px] font-mono font-black text-subtext hover:text-primary transition-colors uppercase tracking-[0.2em]"
                  >
                    &larr; Exit_Terminal
                  </button>
                </div>
             </div>
             <Dashboard />
          </div>
        )}
      </main>
      
      <footer className="border-t border-white/5 py-8 mt-auto bg-black/20 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-4 text-center text-[10px] font-mono font-bold text-subtext uppercase tracking-[0.3em]">
          <p>&copy; {new Date().getFullYear()} SafeToSubmit_Forensics. Secure Transmission Enabled.</p>
        </div>
      </footer>
    </div>
  );
};

export default App;